import { Link } from "react-router-dom";

const NotFound = () => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                textAlign: "center"
            }}
        >
            <h1>404</h1>
            <h2>Página não encontrada</h2>
            <p>A página que você tentou acessar não existe.</p>

            <Link to="/" style={{color:"yellow"}}>
                Voltar para o catálogo
            </Link>
        </div>
    );
};

export default NotFound;